var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9827 2.5H8.50957C8.38434 2.49964 8.26038 2.5252 8.1455 2.57506C8.03062 2.62492 7.9273 2.69801 7.84204 2.78974C7.75677 2.88146 7.6914 2.98984 7.65005 3.10805C7.60869 3.22626 7.59224 3.35175 7.60173 3.47662V21.5922C7.60173 21.8329 7.69738 22.0638 7.86763 22.2341C8.03788 22.4044 8.2688 22.5 8.50957 22.5H16.9827C17.2211 22.4964 17.4485 22.3991 17.6158 22.2293C17.7831 22.0594 17.8769 21.8306 17.8768 21.5922V3.47662C17.8862 3.3529 17.8702 3.22856 17.8297 3.11128C17.7891 2.994 17.725 2.88627 17.6412 2.79475C17.5574 2.70323 17.4558 2.62986 17.3425 2.57916C17.2293 2.52847 17.1068 2.50153 16.9827 2.5Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9982 21.4507H10.6177C13.2446 18.6274 15.5158 12.0314 15.9982 3.54883C16.1093 3.55019 16.2189 3.57431 16.3202 3.61968C16.4216 3.66506 16.5126 3.73074 16.5876 3.81266C16.6626 3.89458 16.72 3.991 16.7563 4.09598C16.7925 4.20095 16.8069 4.31225 16.7985 4.42299V20.6381C16.7985 20.8515 16.7146 21.0564 16.5648 21.2084C16.4151 21.3605 16.2116 21.4475 15.9982 21.4507Z",
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0386 2.5V4.02886C10.0386 4.4087 10.3465 4.71662 10.7263 4.71662H14.7518C15.1316 4.71662 15.4395 4.4087 15.4395 4.02886V2.5H10.0386Z",
    fill: "#363A45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.b79fab2d9f4bb6da755b3f10d18c8145.svg";
export { ForwardRef as ReactComponent };